import { gql } from '@fdc/__generated__';

export const SHOPPING_LISTS = gql(/* GraphQL */ `
  query ShoppingLists {
    lists {
      id
      referenceId
      name
      productCount
      freeTextCount
    }
  }
`);
